import React from 'react';
import PropTypes from 'prop-types';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { Redirect, Switch } from 'react-router-dom';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';

import gettingStartedReducers from './reducers';

const importGettingStartedRoutes = () => import(/* webpackChunkName: "getting-started-main" */ './containers/GettingStartedContainer');
const importLearnAutomationRoutes = () => import(/* webpackChunkName: "getting-started-automation" */ './containers/LearnAutomationContainer');
const importManualTestingRoutes = () => import(/* webpackChunkName: "getting-started-manual" */ './containers/ManualTestingContainer');
const importIntegrateTestsRoutes = () => import(/* webpackChunkName: "getting-started-manual" */ './containers/IntegrateTestsContainer');
const importGettingStartedGuidesRoutes = () => import(/* webpackChunkName: "getting-started-manual" */ './containers/GettingStartedGuideContainer');

const GettingStartedRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.GROWTH}>
      <Switch>
        {!isSupportedFeature(features.GETTING_STARTED) && (
          <Redirect
            from={match.url}
            to="/dashboard"
          />
        )}
        <BundleRoute
          load={importLearnAutomationRoutes}
          path={`${match.url}/learn-automation`}
        />
        <BundleRoute
          load={importManualTestingRoutes}
          path={`${match.url}/manual-testing`}
        />
        <BundleRoute
          load={importIntegrateTestsRoutes}
          path={`${match.url}/automated-testing/:activeTab?`}
        />
        <BundleRoute
          load={importGettingStartedGuidesRoutes}
          path={`${match.url}/guides/:guide?`}
        />
        <BundleRoute
          load={importGettingStartedRoutes}
          path={`${match.url}/:activeTestingMethod?`}
        />
      </Switch>
    </SentryBoundary>
  </LoginRequiredContainer>
);

GettingStartedRoutes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

export default dynamic(
  'apps.gettingStarted', attachReducer(gettingStartedReducers),
)(GettingStartedRoutes);
